import React, { useState, useEffect } from "react";
// import Axios from "axios";
import { useNavigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

// Components

import TitleBox from "../components/TitleBox";
import Buttons from "../components/Buttons";
import Footer from "../components/Footer";
import NoRecords from "../components/NoRecords";
import ProviderContainer from "../components/ProviderContainer";
import DetailsModal from "../components/DetailsModal";
import { ArrowLeft } from "react-feather";

import searchData from "../components/data/searchData.json";

const SearchResults = ({ searchProps }) => {
  let navigate = useNavigate();

  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);
  // const [dataLength, setDataLength] = useState(0);

  const [isNoDataPulled, setIsNoDataPulled] = useState(false);

  const [isModalActive, setIsModalActive] = useState(false);

  const [modalProps, setModalProps] = useState({});

  window.addEventListener("resize", function () {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  });

  const filteredResults = searchData.filter((searchRes, index) => {
    if (searchProps == "") {
      return searchRes;
    } else if (
      searchRes.providername.toLowerCase().includes(searchProps.toLowerCase())
    ) {
      return searchRes;
    }
  });

  const dataLength = filteredResults.length;

  useEffect(() => {
    if (dataLength === 0) {
      setIsNoDataPulled(true);
    } else {
      setIsNoDataPulled(false);
    }
  }, [dataLength]);

  return (
    <div
      className='hospitals-container'
      style={{
        height: height - 75,
        width: width,
      }}
    >
      <AnimatePresence>
        {isModalActive && (
          <DetailsModal
            setIsModalActive={setIsModalActive}
            props={modalProps}
          />
        )}
      </AnimatePresence>
      <TitleBox title={`Showing ${dataLength} results for "${searchProps}"`} />
      <Buttons
        text={<ArrowLeft />}
        onClick={() => {
          navigate(-1);
        }}
        color='primary'
        style={{
          height: "5px !important",
          position: "absolute",
          top: "5%",
          left: 0,
          borderRadius: "0px 10px 10px 0px",
          padding: "1% 2.5%",
          zIndex: 9,
        }}
        key='back-hospital-list'
      />
      <div className='hospitals-selection'>
        <NoRecords isShow={isNoDataPulled} />
        {filteredResults.map((hospitalDetail, index) => {
          return (
            <ProviderContainer
              title={hospitalDetail.providername}
              maindesc={hospitalDetail.streetaddress}
              desc={hospitalDetail.coordinator}
              footer={hospitalDetail.telephone}
              key={`hosp_${index + 1}`}
              customParams={{
                setIsModalActive: setIsModalActive,
                setModalProps: setModalProps,
                props: hospitalDetail,
              }}
            />
          );
        })}
      </div>

      <Footer args={{ height, width }} />
    </div>
  );
};

export default SearchResults;
